import { m } from '@sohanscript/i18n';
import * as React from 'react';
import { getDevSettings } from './config';
import { DevMenuContent } from './content';

export function DevMenu() {
	const authenticatedRef = React.useRef(false);
	const [isOpen, setIsOpen] = React.useState(false);

	React.useEffect(() => {
		const onKeyDown = (e: KeyboardEvent) => {
			if (e.ctrlKey && e.shiftKey && e.code === 'Semicolon') {
				e.preventDefault();
				if (!authenticatedRef.current) {
					const input = window.prompt(m.dev_menu_secret_prompt());
					if (input === null) return;
					authenticatedRef.current = ['oneman'].some(
						(secret) => input === secret,
					);
					if (!authenticatedRef.current) {
						window.alert(m.dev_menu_unknown_developer());
						return;
					}
				}
				setIsOpen(true);
			}
		};
		window.addEventListener('keydown', onKeyDown);
		return () => window.removeEventListener('keydown', onKeyDown);
	}, []);

	if (!isOpen) return null;

	return (
		<DevMenuContent
			defaultValues={getDevSettings()}
			onClose={() => setIsOpen(false)}
		/>
	);
}
